import React from 'react';
import { TextInput } from '@instinet-analytics/semantic-ui-components';

interface NumberControlProps {
    columnName?: string | null;
    value?: string;
    onInputEnter: () => void;
    onChange: (value: string) => void;
}

export default function NumberControl(props: NumberControlProps) {
    const { columnName, value, onChange, onInputEnter } = props;
    return (
        <TextInput
            value={value || ''}
            onChange={onChange}
            onEnter={onInputEnter}
            placeholder={`Enter a ${columnName}`}
        />
    );
}
